export default "__VITE_ASSET__Dt$A1t0O__"